import { useMutation } from "react-query";
import { useAppContext } from "../AppProviders";
import { API_URL } from "./helpers";
import { ApiKey } from "./Keys";

export function useGetApiKey() {
  const { requestApi } = useAppContext();
  const getApiKeys = async (company_uuid: string): Promise<ApiKey> => {
    return requestApi
      .get(
        `${API_URL}/api_keys/companies/${company_uuid}` //individual
      )
      .then((response) => {
        return response.data;
      });
  };

  const mutationResult = useMutation(
    (company_uuid: string) => getApiKeys(company_uuid),
    {}
  );

  return {
    ...mutationResult,
  };
}

export function useGenerateNewApiKey() {
  const { requestApi } = useAppContext();
  const generateNewApiKey = async (company_uuid: string): Promise<ApiKey> => {
    return requestApi
      .post(`${API_URL}/api_keys?company_uuid=${company_uuid}`)
      .then((response) => {
        return response.data;
      });
  };

  const mutationResult = useMutation(
    (company_uuid: string) => generateNewApiKey(company_uuid),
    {}
  );

  return {
    ...mutationResult,
  };
}

export function useDeleteApiKey() {
  const { requestApi } = useAppContext();

  const deleteApiKey = async (company_uuid: string): Promise<string> => {
    return requestApi
      .delete(`${API_URL}/api_keys/companies/${company_uuid}`)
      .then((response) => {
        return response.data;
      });
  };

  const mutationResult = useMutation(
    (apiKeyId: string) => deleteApiKey(apiKeyId),
    {}
  );

  return {
    ...mutationResult,
  };
}
